/**
 * H5 大屏舞台注册表：新增玩法只需要在 H5_STAGE_BY_GAME 里补一条映射，
 * 然后在 screen.vue 里挂一个舞台组件即可。
 * 玩法 key 与后管 registry.js / 后端 PartyGameCatalog 保持一致。
 */

const LOTTERY_KEYS = [
  'rolling_avatar', 'open_box', 'marquee', 'slot', 'draw_machine', 'classic_lottery', 'listdraw',
  'lottery_3d', 'photo_lottery', 'ticket_lottery', 'seat_lottery', 'barrage_lottery', 'glow_lottery',
  'blessing_lottery', 'gamble_lottery', 'welfare_lottery', 'lucky_100', 'pinball'
]

const SCORE_KEYS = [
  'tap_race', 'money', 'shake', 'shake_landscape', 'tugofwar', 'match', 'puzzle', 'answer',
  'tornado', 'tap_lr', 'swipe_lr', 'spin', 'quick_hands', 'lucky_bonus', 'shoot', 'cut', 'knock',
  'jump', 'rhythm', 'points', 'chess', 'sing', 'guess', 'lightup_logo', 'lightup_map', 'buzz', 'duel'
]

const MESSAGE_KEYS = ['barrage', 'super_barrage', 'wall', 'show_hog', 'like', 'reward', 'question_wall', 'message_wall', 'virtual_role']

const RED_PACKET_KEYS = ['rain', 'grab_packet', 'scratch', 'koi', 'shake_prize', 'voice_treasure', 'happy_taobao', 'code_gift', 'fortune', 'red_rank']

const VOTE_KEYS = ['vote', 'grade', 'pk', 'motion', 'goal', 'auction', 'signature', 'trade_fair']

const DISPLAY_KEYS = [
  'welcome', 'scan', 'logo_signin', 'year_end_signin', 'sign_tree', 'sign_3d', 'area_signin',
  'mosaic_signin', 'sign_book', 'signature_wall', 'avatar_frame', 'comic_avatar', 'photo_wall',
  'guest_show', 'activity_flow', 'live', 'microsite', 'location_limit', 'copyright',
  'launching', 'countdown', 'firework', 'starter'
]

export const H5_STAGE_BY_GAME = {
  lottery: 'lottery',
  rolling_avatar: 'rolling_avatar',
  open_box: 'open_box',
  sound_wave: 'sound_wave',
  photo_lottery: 'photo_lottery'
}

LOTTERY_KEYS.forEach(key => {
  if (!H5_STAGE_BY_GAME[key]) H5_STAGE_BY_GAME[key] = 'lottery_variant'
})
SCORE_KEYS.forEach(key => {
  if (!H5_STAGE_BY_GAME[key]) H5_STAGE_BY_GAME[key] = 'score'
})
MESSAGE_KEYS.forEach(key => {
  H5_STAGE_BY_GAME[key] = 'message'
})
RED_PACKET_KEYS.forEach(key => {
  H5_STAGE_BY_GAME[key] = 'red_packet'
})
VOTE_KEYS.forEach(key => {
  H5_STAGE_BY_GAME[key] = 'vote'
})
DISPLAY_KEYS.forEach(key => {
  H5_STAGE_BY_GAME[key] = 'signin_wall'
})

/** 舞台 key 按长度倒序，避免短 key 误匹配（模块加载时算一次，避免每次渲染排序） */
const SORTED_STAGE_KEYS = Object.keys(H5_STAGE_BY_GAME).sort((a, b) => b.length - a.length)

/** 抽奖类舞台（全屏动效，不铺场景背景图） */
export const H5_FX_STAGES = ['lottery', 'rolling_avatar', 'open_box', 'lottery_variant', 'photo_lottery']

/** 计分类舞台（跑酷 / 数钱 / 摇一摇等共用榜单舞台） */
export const H5_SCORE_STAGES = ['score']

export function isFxStageKind(kind) {
  return H5_FX_STAGES.indexOf(kind) >= 0
}

export function isScoreStageKind(kind) {
  return H5_SCORE_STAGES.indexOf(kind) >= 0
}

/** 解析 gameKey 对应的舞台类型 */
export function resolveStageKindByGame(gameKey) {
  return H5_STAGE_BY_GAME[gameKey] || ''
}

/**
 * 解析当前大屏应使用的舞台类型
 * @param {Object} ctx { sceneKey, scene, phase, partyConfig }
 */
export function resolveH5StageKind(ctx) {
  const { sceneKey, scene, phase, partyConfig } = ctx || {}
  const config = partyConfig || {}
  const key = String(sceneKey || '')

  // 声浪活动整场只有声浪舞台（历史行为保持一致）
  if (config.productKey === 'sound_wave') return 'sound_wave'

  // 1. 当前场景显式 gameKey 优先
  const sceneGame = scene && scene.gameKey
  if (sceneGame && H5_STAGE_BY_GAME[sceneGame]) return H5_STAGE_BY_GAME[sceneGame]

  // 2. 抽奖进行中
  if (phase === 'LOTTERY') return 'lottery'

  // 3. 场景 key 前缀推断（按 key 长度倒序，避免短 key 误匹配）
  for (let i = 0; i < SORTED_STAGE_KEYS.length; i++) {
    if (key.indexOf(SORTED_STAGE_KEYS[i]) >= 0) return H5_STAGE_BY_GAME[SORTED_STAGE_KEYS[i]]
  }

  // 4. 活动配置里已启用的玩法
  const games = config.games || []
  const enabled = games.find(g => g && g.enabled !== false && H5_STAGE_BY_GAME[g.key])
  if (enabled) return H5_STAGE_BY_GAME[enabled.key]

  // 5. 产品兜底
  if (config.productKey && H5_STAGE_BY_GAME[config.productKey]) {
    return H5_STAGE_BY_GAME[config.productKey]
  }
  return ''
}
